// axiosInstance.js
import axios from "axios";
import { API_URL } from "../Config/config";
import { showBlockedPopup } from "../utils/popupHandler";

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(async (config) => {
  const token = localStorage.getItem("token");
  
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  } else {
    config.headers["Authorization"] = `Bearer SKIP`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      //   authService.autoLogout();
      localStorage.clear();
      window.location.href = "/login";
    }

    if (error?.response?.status === 403) {
      showBlockedPopup();
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
